import { Link } from "react-router-dom";

// One Button for every CTA on the site. Was previously ~10 near-identical inline
// style={{}} blocks across pages - none of which could get a real :hover state since
// inline styles can't express pseudo-classes. This one can, via the .btn* classes in
// tokens.css.
export default function Button({
  variant = "primary",
  size = "md",
  block = false,
  to,
  href,
  external = false,
  className = "",
  children,
  ...rest
}) {
  const classes = ["btn", `btn-${variant}`, `btn-${size}`, block ? "btn-block" : "", className]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
}
